import { useContext, useEffect } from 'react';
import { VehicleType } from '../common/CommonTypes';
import { VehicleContext } from '../../context/VehicleContext';
import { useNavigate } from 'react-router';
import { RoutePaths } from '../../Constants/Common';

export const useSelectedVehicle = (): VehicleType => {
    const { vehicles, selectedVehicleIndex } = useContext(VehicleContext);
    const vehicle = vehicles[selectedVehicleIndex];
    const navigate = useNavigate();

    useEffect(() => {
        if (vehicle === undefined) {
            navigate(RoutePaths.Home);
        }
    }, []);

    return vehicle;
};
